// About named parameters via desctructuring with default values
// `func({ correction = false } = {})`, for example:
// http://exploringjs.com/es6/ch_parameter-handling.html#_named-parameters-via-destructuring

export default class GeoPoint {
	constructor(address_element) {
		const self = this;
		self.address_element = address_element;
		self.address_element.geo_point = self;

		// Bind Map if data-attribute setted
		const map_data = self.address_element.dataset.map;
		if (map_data) {
			self.map_data = JSON.parse(map_data);

			if (self.map_data.selector) {
				const map_container = document.querySelector(self.map_data.selector);
				if (map_container) {
					self.map = document.querySelector(self.map_data.selector).map_object;
					// Reverse binding
					self.map.geo_points[self.map_data.marker.label] = self;

					// Set marker on map if there are coordinates
					if (self.map_data.marker.coordinates) {
						self._update_marker();
					}
				}
			}
		}
	}

	get address() {
		return this.address_element.innerHTML.trim();
	}

	get coordinates() {
		return this.map_data.marker.coordinates;
	}

	get position() {
		const lat_lng = this.coordinates.replace(/[()]/g, '').split(',');
		if (lat_lng.length < 2) return null;
		return new google.maps.LatLng(...lat_lng);
	}

	_update_marker() {
		if (!this.map) return;
		this.map.update_marker(this.map_data.marker.label, this.position);
	}
}
